import { render, staticRenderFns } from "./Subscriptions.vue?vue&type=template&id=2acf65e9&scoped=true&"
import script from "./Subscriptions.vue?vue&type=script&lang=js&"
export * from "./Subscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acf65e9",
  null
  
)

export default component.exports